<template><svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity=".998" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">
    <path opacity=".998" d="M1 2.67A.732.732 0 0 1 1.781 2H11.93a.732.732 0 0 1 .781.67v7.37a.732.732 0 0 1-.781.67H1.781A.731.731 0 0 1 1 10.04V2.67ZM1 4.684h11.71M4.123 4.68V1M9.588 4.68V1"/>
    <path opacity=".998" d="M3.643 7.425a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM6.855 7.425a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM10.068 7.425a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z"/>
  </g>
</svg>
</template>